export class DadosIes {
  public constructor() {
    this.Nome = [];
    this.CodigoMEC = [];
    this.CNPJ = [];
    this.Endereco = [];
    this.Credenciamento = [];
    this.Recredenciamento = [];
    this.DadosMantenedora = [];
  }

  Nome: string[];
  CodigoMEC: string[];
  CNPJ: string[];
  Endereco: Endereco[];
  Credenciamento: Credenciamento[];
  Recredenciamento: Recredenciamento[];
  DadosMantenedora: DadosMantenedora[];
}

export class Endereco {

  public constructor() {
    this.Logradouro = "";
    this.Bairro = "";
    this.Numero = "-";
    this.Complemento = "-";
    this.CEP = "";
    this.Municipio = "";
    this.CodMunicipio = "";
    this.UF = "";
  }
  Complemento: string;
  Logradouro: string;
  Bairro: string;
  Numero: string;
  CEP: string;
  Municipio: string;
  CodMunicipio: string;
  UF: string;
};

export class Credenciamento {

  public constructor() {
    this.Tipo = "";
    this.Numero = "";
    this.Data = "";
    this.DataPub = "";
    this.SecaoPub = "";
    this.PaginaPub = "";
  }

  Tipo: string;
  Numero: string;
  Data: string;
  DataPub: string;
  SecaoPub: string;
  PaginaPub: string;
};


export class Recredenciamento {

  public constructor() {
    this.Tipo = "";
    this.Numero = "";
    this.Data = "";
    this.DataPub = "";
    this.Secao = "";
    this.Pagina = "";
  }
  Tipo: string;
  Numero: string;
  Data: string;
  Secao: string;
  Pagina: string;
  DataPub: string;
};

export class DadosMantenedora {

  public constructor() {
    this.RazaoSocial = "";
    this.CodMunicipio = "";
    this.CNPJ = "";
    this.Logradouro = "";
    this.Numero = "";
    this.Bairro = "";
    this.CEP = "";
    this.Municipio = "";
    this.UF = "";
  }

  RazaoSocial: string;
  CNPJ: string;
  Logradouro: string;
  Numero: string;
  Bairro: string;
  CEP: string;
  Municipio: string;
  CodMunicipio: string;
  UF: string;
};

